export default "__VITE_ASSET__yAp8UBLi__"